import React, { forwardRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LaboratorySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        children: [/*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsxs(ACol, {
            span: 6,
            children: [/*#__PURE__*/_jsx(Image, {
              src: "drawables/mvc.jpeg",
              preview: false,
              width: "230px"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(Moment, {
                date: moment(),
                format: "DD/MM/YYYY H:m"
              })
            })]
          }), /*#__PURE__*/_jsx(ACol, {
            span: 14,
            offset: 4,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                padding: "8px",
                color: "#EEE",
                background: "#168794",
                clear: "both"
              },
              children: [/*#__PURE__*/_jsx("h2", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "RESULTATS DU LABORATOIRE"
                })
              }), /*#__PURE__*/_jsxs("span", {
                children: ["N\xBA DOSSIER: ", candidat.candidate_code]
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsxs(ACol, {
            span: 24,
            children: [candidat.laboratory_result != null && candidat.laboratory_result.biochimie != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "BIOCHIMIE"
              }),
              column: 2,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GLYCEMIE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.glycemie
                }), " (NORME: 0,7 - 1,2 g/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "UREE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.uree
                }), " (NORME: 15 - 45 mg/dl)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CREATINEMIE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.creatinemie
                }), " (NORME: 0,9 - 1,5 mg/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL TOTAL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_t
                }), " (NORME: 200 - 239 mg/dl)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL HDL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_hdl
                }), " (NORME : 30 - 70 mg/dl)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL LDL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_ldl
                }), " (NORME: 130 - 150 mg/dl)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "TRIGLYCERIDE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.triglyceride
                }), " (NORME: 40 - 160 mg/dl)"]
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GAMMA GT"
                }),
                children: candidat.laboratory_result.biochimie.gamma_gt
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GAMMA GT"
                }),
                children: candidat.laboratory_result.biochimie.gamma_gt
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GOT"
                }),
                children: candidat.laboratory_result.biochimie.got
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GPT"
                }),
                children: candidat.laboratory_result.biochimie.gpt
              })]
            }), /*#__PURE__*/_jsx("br", {}), candidat.laboratory_result != null && candidat.laboratory_result.urine != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "URINE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "SANG"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.sang
                }), "(NORME: N\xE9gatif)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "SUCRE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.sucre
                }), " (NORME: N\xE9gatif)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "ALBUMINE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.albumine
                }), " (NORME: N\xE9gative)"]
              })]
            }), /*#__PURE__*/_jsx("br", {}), candidat.laboratory_result != null && candidat.laboratory_result.hemato != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "HEMATOLOGIE"
              }),
              column: 2,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GLOBULES BLANCS"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.gb
                }), " (NORME: 4,0 - 10 x10^9/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GLOBULES ROUGES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.gr
                }), " (NORME: 3,5 - 5,5 x10^12/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMOGLOBINES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.hemoglobine
                }), " (NORME: 11,5 - 16 g/dl)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMATOCRITE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.hematocrite
                }), " (NORME: 36 - 48 %)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "PLAQUETTE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.plaquette
                }), " (NORME: 100 - 300 x10^9/l)"]
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GROUPE SANGUIN"
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.groupe
                })
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "FACTEUR RHESUS"
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.rhesus
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), candidat.laboratory_result != null && candidat.laboratory_result.ionogramme != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "IONOGRAMME"
              }),
              column: 2,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CALCIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.calcium
                }), " (NORME: 8,4 - 10,2 mg/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "MAGNESIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.magnesium
                }), " (NORME: 1,8 - 2,6 mg/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHLORE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.chlore
                }), " (NORME: 97 - 108 mmol/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "POTASSIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.potassium
                }), " (NORME: 3,6 - 5,5 mmol/l)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "SODIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.sodium
                }), " (NORME: 135 - 150 mmol/l)"]
              })]
            }), /*#__PURE__*/_jsx("br", {}), candidat.laboratory_result != null && candidat.laboratory_result.serologie != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "SEROLOGIE"
              }),
              column: 2,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "AgHBs"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.aghbs
                }), " (NORME: N\xE9gatif)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "AgP26"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.agp26
                }), " (NORME: N\xE9gatif)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CRP"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.crp
                }), " (NORME: N\xE9gatif)"]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.drug_test != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "ADDICTOLOGIE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "ALCOOL"
                }),
                children: candidat.laboratory_result.drug_test.alcool == 0 ? "NEGATIF" : "POSITIF"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "AMPHETAMINES"
                }),
                children: candidat.laboratory_result.drug_test.amphetamine == 0 ? "NEGATIF" : "POSITIF"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "BENZODIAZEPINES"
                }),
                children: candidat.laboratory_result.drug_test.benzodiazepine == 0 ? "NEGATIF" : "POSITIF"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "CANNABINOIDES"
                }),
                children: candidat.laboratory_result.drug_test.cannabinoide == 0 ? "NEGATIF" : "POSITIF"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "OPIACES"
                }),
                children: candidat.laboratory_result.drug_test.opiace == 0 ? "NEGATIF" : "POSITIF"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "COCAINE"
                }),
                children: candidat.laboratory_result.drug_test.cocaine == 0 ? "NEGATIF" : "POSITIF"
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.parasitologie != null && /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "PARASITOLOGIE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "ASPECT"
                }),
                children: candidat.laboratory_result.parasitologie.aspect
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "COULEUR"
                }),
                children: candidat.laboratory_result.parasitologie.color
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "RESULTAT"
                }),
                children: candidat.laboratory_result.parasitologie.result
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Responsable du Laboratoire"
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default LaboratorySheet;